import layout from '@/layout'

export default {
  path: '/hsgt',
  component: layout,
  redirect: '/hsgt/lgt_row',
  name: 'hsgtLgtRow',
  meta: {
    title: 'hsgt',
    icon: 'hsgt'
  },
  children: [
    {
      path: '/hsgt/lgt_row',
      name: 'hsgtLgtRow',
      component: () => import('@/views/lgt/row'),
      meta: {
        title: 'hsgtLgtRow',
        icon: 'hsgt_lgt'
      }
    }
  ]
}
